<template>
    <div>
        <ul v-if="isMobile" class="order-photo-viewer-labels">
            <li class="order-photo-viewer-label" v-if="isFavorite(photo.id)">{{
                $t('selected') }}
            </li>
            <li class="order-photo-viewer-label" v-if="orderedPhotos[photo.id]">
                {{ $t('in_cart') }}
            </li>
        </ul>
        <div v-if="photo" class="order-photo-viewer">
            <vue-loading :active.sync="loading" :is-full-page="false"/>
            <img :src="photo.large_photo" class="d-none" alt="" @load="loading = false">
            <div v-if="!loading" class="order-photo-viewer-img"
                 :style="`background-image: url(${photo.large_photo})`">
                <div class="order-photo-viewer-filename" v-if="isMobile">{{ photo.photo_file_name }}</div>
            </div>
            <div class="order-photo-viewer-nav" v-if="!showFavoritePhotos && albumPhotos && albumPhotos.length > 1 || showFavoritePhotos && favoritePhotos.length > 1">
                <a href="#" id="step1BtnPrev" @click.prevent="prev(photo.id)" :class="['prev', {'prev--disabled': !showPrev}]">
                    <span v-if="showPrev"><span class="material-icon icon-keyboard_arrow_left"/></span>
                    <b-spinner v-else style="width: 3rem; height: 3rem;" type="grow"></b-spinner>
                </a>
                <a href="#" id="step1BtnNext" @click.prevent="next(photo.id)" :class="['next', {'next--disabled': !showNext}]">
                    <span v-if="showNext"><span class="material-icon icon-keyboard_arrow_right"></span></span>
                    <b-spinner v-else style="width: 3rem; height: 3rem;" type="grow"></b-spinner>
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .order-photo-viewer {

        &-nav {
            position: absolute;
            width: 100%;
            height: 0;
            top: 50%;
            left: 0;
            margin-top: -39px;
            z-index: 1;

            .next,
            .prev {
                position: absolute;
                width: 78px;
                height: 85px;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 0;
                text-decoration: none;

                &--disabled {
                    pointer-events: none;
                }

                .loader {
                    animation: loader 2s linear infinite;
                }
            }

            .prev {
                left: 0;
            }

            .next {
                right: 0;
            }

            > a {
                margin: 0 40px;
                color: rgba(#232323, .2);
                transition: color .2s ease;

                &:hover {
                    color: rgba(#232323, .4);
                }

                .material-icon {
                    font-size: 4.87rem !important;
                }
            }
        }

        &-img {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: 50% 50% no-repeat;
            background-size: contain;
            z-index: 0;
        }

        &-filename {
            position: absolute;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            bottom: 30px;
            left: 50%;
            height: 22px;
            border-radius: 11px;
            margin-right: 10px;
            padding: 0 10px;
            font-size: .75rem;
            font-weight: 500;
            color: #212121;
            background-color: #fafafa;
            transform: translateX(-50%);
        }
    }

    body.-is-mobile {

        .order-photo-viewer {

            &-nav {
                margin-top: -84px;

                > a {
                    margin: 0;

                    &,
                    &:hover,
                    &:focus {
                        color: rgba(#fff, .75);
                    }
                }
            }

            &-labels {
                position: absolute;
                width: 100%;
                text-align: center;
                margin: 0;
                padding: 20px;
                list-style: none;
                top: 0;
                left: 0;
                cursor: pointer;
                z-index: 1;
            }

            &-label {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                height: 22px;
                margin-right: 10px;
                padding: 0 10px;
                font-size: .75rem;
                font-weight: 500;
                border-radius: 11px;
                color: #212121;
                background-color: #fff;

                &:last-child {
                    margin-right: 0;
                }
            }

            &-img {
                height: calc(100% - 80px);
            }
        }
    }
</style>

<script>
  import orderStep1 from 'src/mixins/orderStep1Component';

  export default {
    mixins: [orderStep1],
  };
</script>